module.exports = __webpack_public_path__ + "static/media/battery_2.94fbea63.png";